import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const EditProfileComp = (props) => {
  // console.log(props.profile);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [namaRs, setnamaRs] = useState(props?.profile?.namaRs);
  const [namaDirektur, setnamaDirektur] = useState(props?.profile?.direktur);
  const [emailRs, setemailRs] = useState(props?.profile?.email);
  const [telpRs, settelpRs] = useState(props?.profile?.telp);
  const [kodeRs, setkodeRs] = useState(props?.profile?.kodeRs);
  const [website, setwebsite] = useState(props?.profile?.website);
  const [alamatRs, setalamatRs] = useState(props?.profile?.alamat);
  const [namaDepan, setnamaDepan] = useState(
    props.profile.contact_people[0].namaDepan
  );
  const [namaBelakang, setnamaBelakang] = useState(
    props.profile.contact_people[0].namaBelakang
  );
  const [namaPanggilan, setnamaPanggilan] = useState(
    props.profile.contact_people[0].namaPanggilan
  );
  const [emailPic, setemailPic] = useState(
    props.profile.contact_people[0].email
  );
  const [hp1, sethp1] = useState(props.profile.contact_people[0].hp1);
  const [hp2, sethp2] = useState(props.profile.contact_people[0].hp2);
  const [gender, setgender] = useState(props.profile.contact_people[0].gender);
  const [profileId, setprofileId] = useState({});

  const [smtpHost, setsmtpHost] = useState(props?.profile?.smtpHost);
  const [smtpPort, setsmtpPort] = useState(props?.profile?.smtpPort);
  const [smtpUsername, setsmtpUsername] = useState(
    props?.profile?.smtpUsername
  );
  const [smtpPassword, setsmtpPassword] = useState(
    props?.profile?.smtpPassword
  );
  const [smtpEmailFrom, setsmtpEmailFrom] = useState(
    props?.profile?.smtpEmailFrom
  );
  const [statusSendEmail, setstatusSendEmail] = useState(
    props?.profile?.statusSendEmail
  );

  const fetchProfile = async () => {
    // console.log(id)
    // return false
    try {
      const options = {
        url: `/profile/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      setprofileId(data[0].id);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/profile/edit.fetchProfile');
    }
  };

  // console.log(profileId)

  useEffect(() => {
    fetchProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdateProfile = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      namaRs: namaRs,
      kodeRs: kodeRs,
      direktur: namaDirektur,
      alamat: alamatRs,
      telp: telpRs,
      website: website,
      email: emailRs,
      createdBy: "",
      updatedBy: "",
      isValidate: "",
      smtpHost: smtpHost,
      smtpPort: smtpPort,
      smtpUsername: smtpUsername,
      smtpPassword: smtpPassword,
      smtpEmailFrom: smtpEmailFrom,
      statusSendEmail: statusSendEmail,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: `/profile/update/${profileId}`,
      method: "PATCH",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          handleUpdateCp();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  const handleUpdateCp = () => {
    const requestBody = {
      idProfile: profileId,
      namaDepan: namaDepan,
      namaBelakang: namaBelakang,
      namaPanggilan: namaPanggilan,
      email: emailPic,
      hp1: hp1,
      hp2: hp2,
      gender: gender,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: `/contact-person/update-contact-person/${profileId}`,
      method: "PATCH",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Successfully updated Profile!",
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  // console.log(profileId)

  return (
    <>
      <div className="mb-5 row">
        <div className="col-12">
          <h4 className="text-danger">*Semua kolom inputan wajib terisi.</h4>
        </div>
      </div>
      <div className="mb-5 row">
        <div className="col-6">
          <span className="badge badge-info">Data Rumah Sakit</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaRs" className="col-sm-2 col-form-label">
          Nama
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="namaRs"
            onChange={(e) => setnamaRs(e.target.value)}
            value={namaRs || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="direktur" className="col-sm-2 col-form-label">
          Direktur
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="direktur"
            onChange={(e) => setnamaDirektur(e.target.value)}
            value={namaDirektur || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="emailRs" className="col-sm-2 col-form-label">
          Email
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            id="emailRs"
            onChange={(e) => setemailRs(e.target.value)}
            value={emailRs || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="telpRs" className="col-sm-2 col-form-label">
          Telepon
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="telpRs"
            onChange={(e) => settelpRs(e.target.value)}
            value={telpRs || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="website" className="col-sm-2 col-form-label">
          Website
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="website"
            onChange={(e) => setwebsite(e.target.value)}
            value={website || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="alamatRs" className="col-sm-2 col-form-label">
          Alamat
        </label>
        <div className="col-sm-10">
          <textarea
            type="text"
            rows="3"
            className="form-control"
            id="alamatRs"
            onChange={(e) => setalamatRs(e.target.value)}
            value={alamatRs || ""}
          ></textarea>
        </div>
      </div>
      <hr></hr>
      <div className="mb-5 row">
        <div className="col-6">
          <span className="badge badge-info">Data Narahubung</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="gender" className="col-sm-2 col-form-label">
          Gender
        </label>
        <div className="col-sm-10">
          <select
            className="form-control"
            id="gender"
            onChange={(e) => setgender(e.target.value)}
            value={gender || ""}
          >
            <option value="">- Pilih -</option>
            <option value="Pria">Pria</option>
            <option value="Wanita">Wanita</option>
          </select>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaDepan" className="col-sm-2 col-form-label">
          Nama Depan
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="namaDepan"
            onChange={(e) => setnamaDepan(e.target.value)}
            value={namaDepan || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaBelakang" className="col-sm-2 col-form-label">
          Nama Belakang
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="namaBelakang"
            onChange={(e) => setnamaBelakang(e.target.value)}
            value={namaBelakang || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaPanggilan" className="col-sm-2 col-form-label">
          Nama Panggilan
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="namaPanggilan"
            onChange={(e) => setnamaPanggilan(e.target.value)}
            value={namaPanggilan || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="emailPic" className="col-sm-2 col-form-label">
          Email
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            id="emailPic"
            onChange={(e) => setemailPic(e.target.value)}
            value={emailPic || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="hp1" className="col-sm-2 col-form-label">
          Nomor HP 1
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="hp1"
            onChange={(e) => sethp1(e.target.value)}
            value={hp1 || ""}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="hp2" className="col-sm-2 col-form-label">
          Nomor HP 2
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="hp2"
            onChange={(e) => sethp2(e.target.value)}
            value={hp2 || ""}
          />
        </div>
      </div>
      {/* Edit Configuration Email */}
      {
        /* <hr></hr>
        <div className="mb-5 row">
          <div className="col-12">
            <span className="badge badge-info">Pengaturan Email</span>
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="statusSendEmail" className="col-sm-2 col-form-label">
            Notifikasi Email
          </label>
          <div className="col-sm-10">
            <select
              className="form-control"
              id="statusSendEmail"
              onChange={(e) => setstatusSendEmail(e.target.value)}
              value={statusSendEmail || ""}
            >
              <option value="">- Pilih -</option>
              <option value="yes">Aktif</option>
              <option value="no">Non Aktif</option>
            </select>
            <small className="text-info">
              Untuk mengaktifkan notifikasi email pastikan memilih <b>Aktif</b> &
              melengkapi inputan di bawah ini.
            </small>
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="smtpHost" className="col-sm-2 col-form-label">
            SMTP Host
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              id="smtpHost"
              onChange={(e) => setsmtpHost(e.target.value)}
              value={smtpHost || ""}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="smtpPort" className="col-sm-2 col-form-label">
            SMTP Port
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              id="smtpPort"
              onChange={(e) => setsmtpPort(e.target.value)}
              value={smtpPort || ""}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="smtpUsername" className="col-sm-2 col-form-label">
            SMTP Username
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              id="smtpUsername"
              onChange={(e) => setsmtpUsername(e.target.value)}
              value={smtpUsername || ""}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="smtpPassword" className="col-sm-2 col-form-label">
            SMTP Password
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              id="smtpPassword"
              onChange={(e) => setsmtpPassword(e.target.value)}
              value={smtpPassword || ""}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="smtpEmailFrom" className="col-sm-2 col-form-label">
            Email From
          </label>
          <div className="col-sm-10">
            <input
              type="email"
              className="form-control"
              id="smtpEmailFrom"
              onChange={(e) => setsmtpEmailFrom(e.target.value)}
              value={smtpEmailFrom || ""}
            />
          </div>
        </div> */
      }
      <div className="mt-10 mb-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleUpdateProfile()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditProfileComp;
